import { Toast } from 'bootstrap';

document.addEventListener("DOMContentLoaded", function(event) {
  var toastElList = [].slice.call(document.querySelectorAll('.toast'))
  var toastList = toastElList.map(function (toastEl) {
    const toast = new Toast(toastEl, {autohide: false})
    toast.show()
  })
})
